namespace GeniuzPOS.Inventory {
    export namespace IcStockAdjustOutDtService {
        export const baseUrl = 'Inventory/IcStockAdjustOutDt';

        export declare function Create(request: Serenity.SaveRequest<IcStockAdjustOutDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IcStockAdjustOutDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockAdjustOutDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockAdjustOutDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/IcStockAdjustOutDt/Create",
            Update = "Inventory/IcStockAdjustOutDt/Update",
            Delete = "Inventory/IcStockAdjustOutDt/Delete",
            Retrieve = "Inventory/IcStockAdjustOutDt/Retrieve",
            List = "Inventory/IcStockAdjustOutDt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcStockAdjustOutDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
